import CommonUser from '../../models/commonUser'
export default class ResourceItem {
    /**
     * @type {string}
     * @memberof ResourceItem
     * @name 资源ID
     */
    public resourceId: string
    /**
     * @type {string}
     * @memberof ResourceItem
     * @name 资源名称
     */
    public title: string
    /**
     * @type {number}
     * @memberof ResourceItem
     * @name 音视频时长，单位s
     */
    public duration: number
    /**
     * @type {number}
     * @memberof ResourceItem
     * @name 资源文件大小，单位B
     */
    public size: number
    /**
     * @type {string}
     * @memberof ResourceItem
     * @name 资源分类ID
     */
    public categoryId: string
    /**
     * @type {string}
     * @memberof ResourceItem
     * @name 资源分类名称
     */
    public categoryName: string
    /**
     * @type {CommonUser}
     * @memberof ResourceItem
     * @name 上传者
     */
    public uploader: CommonUser
    /**
     * @type {number}
     * @memberof ResourceItem
     * @name 文件上传时间（时间戳）
     */
    public createTime: number
    /**
     * @type {string}
     * @memberof ResourceItem
     * @name 转换类型(SUCCESS-成功，CONVERTING-转换中，FAIL-失败)
     */
    public convertType: string
    /**
     * @type {string}
     * @memberof ResourceItem
     * @name 资源类型（VIDEO-视频，AUDIO-⾳频，DOCUMENT-⽂档）
     */
    public resourceType: string
    /**
     * @type {string}
     * @memberof ResourceItem
     * @name 后缀名
     */
    public suffix: string
    /**
     * @type {string}
     * @memberof ResourceItem
     * @name 资源路径
     */
    public url: string
    constructor({
        resourceId = '',
        title = '',
        duration = null,
        size = null,
        categoryId = '',
        categoryName = '',
        uploader = new CommonUser(),
        createTime = null,
        convertType = '',
        resourceType = '',
        suffix = '',
        url = ''
    } = {}) {
        this.resourceId = resourceId
        this.title = title
        this.duration = duration
        this.size = size
        this.categoryId = categoryId
        this.categoryName = categoryName
        this.uploader = uploader
        this.createTime = createTime
        this.convertType = convertType
        this.resourceType = resourceType
        this.suffix = suffix
        this.url = url
    }
}